import React from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider, useAuth } from "@/lib/auth";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import Dashboard from "@/pages/Dashboard";
import Templates from "@/pages/Templates";
import Editor from "@/pages/Editor";
import Generate from "@/pages/Generate";
import BulkGenerate from "@/pages/BulkGenerate";
import Library from "@/pages/Library";
import Billing from "@/pages/Billing";
import Admin from "@/pages/Admin";
import AppLayout from "@/pages/AppLayout";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 font-mono">LOADING...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function RootRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route element={<Protected><AppLayout /></Protected>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/templates" element={<Templates />} />
        <Route path="/templates/:id/edit" element={<Editor />} />
        <Route path="/templates/new" element={<Editor />} />
        <Route path="/generate/:templateId" element={<Generate />} />
        <Route path="/bulk/:templateId" element={<BulkGenerate />} />
        <Route path="/library" element={<Library />} />
        <Route path="/billing" element={<Billing />} />
        <Route path="/admin" element={<Admin />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <RootRouter />
          <Toaster position="top-right" theme="light" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
